import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicButton } from 'core/components';

function PatientNewFlowDeleteInsurancePolicyConfirmModalTemplate({ patientNewFlowDeleteInsurancePolicyConfirmModalStore, t}) {
    const {
        modalParams,
        onConfirm,
        isDeleting
    } = patientNewFlowDeleteInsurancePolicyConfirmModalStore;
    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title u-mar--bottom--sml'>Are you sure you want to Delete this Insurance Policy</h3>
            </div>
            <div className="modal__body">
                <h3 className='modal__header__title u-mar--bottom--sml'>This action should only be done if the policy was added in error.</h3>
                <h3 className='modal__header__title'>If there is a new policy that is replacing this one, exit this screen and click on the change icon to add the new policy.</h3>
            </div>
            <div className='modal__footer'>
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => modalParams.close()}
                />
                <BaasicButton
                    className='btn btn--med btn--primary'
                    label={t('EDIT_FORM_LAYOUT.CONTINUE')}
                    onClick={() => onConfirm()}
                    disabled = {isDeleting}
                    rotate icon={
                        isDeleting 
                            ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                            : 'u-display--none'
                    }
                    focused={true}
                />
            </div>
        </section>
    )
}
 
PatientNewFlowDeleteInsurancePolicyConfirmModalTemplate.propTypes = {
    patientNewFlowDeleteInsurancePolicyConfirmModalStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(PatientNewFlowDeleteInsurancePolicyConfirmModalTemplate);
